import uk from 'date-fns/locale/uk';
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useController, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

registerLocale('uk', uk);

const DateTimePicker = ({ id, name, label, min, max, className, showError = true, disabled = false }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
    rules: {
      required: {
        value: true,
        message: "Це поле є обов'язковим",
      },
    },
  });

  return (
    <div className="relative w-full">
      {label && <label className="block text-xs md:text-sm m-1 text-gray-700">{label}</label>}
      <DatePicker
        selected={value}
        onChange={onChange}
        showTimeSelect
        minDate={min}
        maxDate={max}
        timeFormat="HH:mm"
        timeIntervals={30}
        timeCaption="Time"
        locale="uk"
        dateFormat="yyyy-MM-dd HH:mm"
        id={id}
        className={twMerge('input', className)}
        disabled={disabled}
      />
      {showError && errors[name] && <div className="text-xs text-contrast1 mt-1">{errors[name].message}</div>}
    </div>
  );
};

export default DateTimePicker;
